import { useState, useEffect } from "react"
import { AudioPlayButton, AudioRendererProps, MediaMetadata } from "./audioPlayButton";
import { AodFloatingPlayer } from "./aodFloatingPlayer";
import { ArticleData } from "../../../../articlePage/stateInterfaces";
import { getQueryStringValue } from "../../../widgetsUtils";

interface PodcastPlayerProps {
    audioUrl: string
    title: string
    durationSeconds: number
    className: string
    isMobileWeb?: boolean
    browserDisplayMediaMetaData?: MediaMetadata
    articleLink?: string
    articleData?: ArticleData
    rangeThumbColor?: string
    rangeColor?: string
    rangeProgressColor?: string
    shouldAudioAutoplay?:boolean
    shouldRedirectToArticle?:boolean
}

export function PodcastPlayer(props: PodcastPlayerProps) {
    const { className, title, isMobileWeb, articleLink, articleData, rangeThumbColor, rangeColor, rangeProgressColor, shouldAudioAutoplay, shouldRedirectToArticle } = props;

    return (
        <AudioPlayButton
            {...props}
            isLive={'false'}
            articleData={articleData}
            renderer={(props: AudioRendererProps) => (<ButtonRnederer {...props} shouldAudioAutoplay={shouldAudioAutoplay} className={className} articleData={articleData} shouldRedirectToArticle={shouldRedirectToArticle} />)}
            floatingPlayerRenderer={(props) => (
                <AodFloatingPlayer
                    {...props}
                    title={title}
                    isMobileWeb={isMobileWeb}
                    articleLink={articleLink}
                    rangeThumbColor={rangeThumbColor}
                    rangeColor={rangeColor}
                    rangeProgressColor={rangeProgressColor}
                />
            )}
        />
    )
}

PodcastPlayer.siteScriptName = "PodcastPlayer"

export function ButtonRnederer({ isAudioPlaying, onTogglePlayPause, className, articleData, shouldAudioAutoplay, shouldRedirectToArticle }: AudioRendererProps & { className: string, articleData?: ArticleData, shouldRedirectToArticle?:boolean }) {

    const audioArticleData = articleData && articleData.specialData && articleData.specialData.audioData
    const category = articleData && articleData.category ? articleData.category.textToShow : "";
    let scriptObj = {}

    if (articleData && audioArticleData) {
        scriptObj = {
            id: articleData.articleId,
            name: articleData.title,
            title: `${category} - ${articleData.title}`,
            durationSeconds: audioArticleData.durationSeconds,
            imageUrl: audioArticleData.imageUrl,
            audioUrl: audioArticleData.audioUrl,
            articleLink: articleData.publishedLink
        };
    }
 
    useEffect(() => {
        if (shouldAudioAutoplay && !isAudioPlaying) {
            setTimeout(() => {
                onTogglePlayPause();
            }, 500);
        }
    }, [shouldAudioAutoplay]);

    const getPodcastDataOnClick = () => {
        if (window.webkit && window.webkit.messageHandlers) {
            window.webkit.messageHandlers.onClickPodcastData.postMessage(JSON.stringify(scriptObj));
        }

        if (window.Android) {
            window.Android.onClickPodcastData(JSON.stringify(scriptObj))
        }
    }

    return (
        articleData && typeof window !== "undefined" && getQueryStringValue("IsApp") && !window.disableAppNativePlayer ?
            <div className="preview-audio-play-button" onClick={getPodcastDataOnClick}>
                <div className="audio-play-button-status"></div>
            </div>
            :
           shouldRedirectToArticle ? <a href={articleData.publishedLink} className={className}>
            <div className={`audio-play-button-status ${isAudioPlaying ? "pause" : ""}`} ></div>
           </a>
            :
             <button className={className} onClick={onTogglePlayPause} aria-label={isAudioPlaying ? "pause" : "play"} >
                <div className={`audio-play-button-status ${isAudioPlaying ? "pause" : ""}`} ></div>
            </button>
    );
}